<template>
    <ModalComponent
        name='crear-codigos'
        title='Crear códigos de invitación para la categoría'
        v-on:close="() => close(false)"
        v-if="!loading"
    >
        <FormCrearCodigos :cantidad_codigos="cantidad_codigos" :usos="usos" @terminado="crear"></FormCrearCodigos>
    </ModalComponent>
    <LoaderComponent v-else></LoaderComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import FormCrearCodigos from '../components/FormCrearCodigos.vue';

export default {
    data() {
        return {
            loading: false,
            cantidad_codigos: null,
            usos: null
        }
    },
    methods: {
        close() {
            this.cantidad_codigos = null;
            this.usos = null;
            this.$emit('close', 'crear-codigos');
        },
        crear(usos, cantidad_codigos) {
            this.loading = true;

            var params = {
                filters : {},
                teatro_id: this.$store.getters.getTeatro.id,
                categoria_id: this.$route.params.categoria_id,
                cantidad_codigos: cantidad_codigos,
                usos: usos
            }

            this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.codigos_invitacion.crear'), params).then(res => {
                this.$toast.success('Códigos creados correctamente.');
                this.$emit('terminado');
                this.close();
            }).finally(() => this.loading = false);
        },
    },
    components: {
        ModalComponent, FormCrearCodigos
    }
}
</script>
